'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _SolutionOfferSustainability = require('./SolutionOfferSustainability.css');

var _SolutionOfferSustainability2 = _interopRequireDefault(_SolutionOfferSustainability);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SolutionOfferSustainability = (_dec = (0, _reactCssModules2.default)(_SolutionOfferSustainability2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(SolutionOfferSustainability, _Component);

  function SolutionOfferSustainability(props) {
    (0, _classCallCheck3.default)(this, SolutionOfferSustainability);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SolutionOfferSustainability.__proto__ || (0, _getPrototypeOf2.default)(SolutionOfferSustainability)).call(this, props));

    _this.state = {
      title: 'Offer sustainable investments',
      description: 'If a retirement plan doesn’t offer sustainable options, employees are being forced to assume the financial risks of unsustainable investing.',
      url: _config2.default.domain + _config2.default.routes.solutionOfferSustainability
    };
    return _this;
  }

  (0, _createClass3.default)(SolutionOfferSustainability, [{
    key: 'render',
    value: function render() {
      var aysLogo = require('../../../static/images/AsYouSow_Logo_color.svg');

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(
          'div',
          { styleName: 'section-top-faq-background' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'section',
              { styleName: 'section-top-faq-cell' },
              _react2.default.createElement(
                'div',
                { styleName: 'issue-top-label' },
                'SOLUTION: ',
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.title
                )
              ),
              _react2.default.createElement(
                'h1',
                { styleName: 'issue-top-headline' },
                'Employees need access to sustainable investing'
              ),
              _react2.default.createElement(
                'h2',
                { styleName: 'issue-top-copy' },
                'If a retirement plan doesn\u2019t offer sustainable options, employees are being forced to assume the financial risks of unsustainable investing.'
              )
            )
          )
        ),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'section',
            { styleName: 'section' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 4 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'issue-second-headline' },
                  _react2.default.createElement(
                    'span',
                    { style: { whiteSpace: 'nowrap' } },
                    '\u2014\u2014\u2014\u2014'
                  ),
                  _react2.default.createElement('br', null),
                  'Retirement plans are still heavily invested in sustainability risks'
                )
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 8 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'issue-second-copy' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'Large investors like pension plans, university endowments, and insurance companies have started moving to make sure their portfolios are properly addressing sustainability risks like climate change, gun violence, racial justice, and gender inequality. But employer-offered retirement plans are not moving fast enough to shift towards sustainable investing \u2013 in part because asset managers like Vanguard, BlackRock, and Fidelity aren\u2019t doing enough to help them shift.'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Retirement plans should offer sustainable investment options that are fossil free, deforestation free, gun free, prison free, weapon free, tobacco free, and invest with a gender lens. Without sustainable investment options, plan participants are forced to assume financial risks associated with unsustainable investing. Do you want to be the \u201Cinvestor of last resort\u201D in fossil fuels and other risky industries, after large investors have fled?'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'section',
            { styleName: 'section' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 6 },
                _react2.default.createElement('div', { styleName: 'img-issue' })
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 6 },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    { styleName: 'issue-focus-label' },
                    'WHY OFFERING SUSTAINABILITY MATTERS'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'issue-focus-headline' },
                    'Unsustainable investments carry financial risk'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'issue-focus-copy' },
                    _react2.default.createElement(
                      'p',
                      null,
                      'The financial risks of investing unsustainably, like stranded assets, reputational risk, and other negative impacts of unsustainable business practices can destroy shareholder value.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'The goal of sustainable investing is to avoid financial risks while supporting the transition to a regenerative economy that is based on justice and sustainability.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.eduCenterFinRisks,
                          title: 'Financial risks of unsustainable investments',
                          xstrong: true
                        },
                        'Learn more',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'section-solutions-faq-background' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'section',
              { styleName: 'section section-solutions-faq' },
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 6 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'section-solutions-faq-cell' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-solutions-label' },
                      'Who we are'
                    ),
                    _react2.default.createElement('img', {
                      src: aysLogo,
                      alt: 'As You Sow',
                      styleName: 'ays-logo'
                    }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-solutions-copy' },
                      _react2.default.createElement(
                        'p',
                        null,
                        'Invest Your Values is a project of ',
                        _react2.default.createElement(
                          'i',
                          null,
                          'As You Sow'
                        ),
                        ', the nation\u2019s non-profit leader in shareholder advocacy. Founded in 1992, we harness shareholder power to create lasting change that benefits people, planet, and profit.'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-link' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.about,
                          title: 'About us',
                          xstrong: true
                        },
                        'About us',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 6 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'section-solutions-faq-cell' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-label' },
                      'FAQs'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-headline' },
                      'Answers to common questions about how retirement plans and asset managers are financing unsustainable business practices.'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-item' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs + '#do-i-have-to-sacrifice-returns-in-order-to-invest-sustainably-',
                          title: 'Do I have to sacrifice returns in order to invest sustainably?',
                          xstrong: true
                        },
                        'Do I have to sacrifice returns in order to invest sustainably?'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-item' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs + '#why-should-retirement-plans-add-a-sustainable-investment-option-',
                          title: 'Why should retirement plans add a sustainable investment option?',
                          xstrong: true
                        },
                        'Why should retirement plans add a sustainable investment option?'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-link' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs,
                          title: 'FAQs',
                          xstrong: true
                        },
                        'View all >>'
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null)
          )
        )
      );
    }
  }]);
  return SolutionOfferSustainability;
}(_react.Component)) || _class);
exports.default = SolutionOfferSustainability;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/SolutionOfferSustainability/SolutionOfferSustainability.js
// module id = 1499
// module chunks = 0